module.exports = __webpack_public_path__ + "static/media/image-effect-preview-mobile.ffaa34cb.png";